/** 本地图片工具函数 */

export const img = (path: string) => `${import.meta.env.BASE_URL}images/${path}`;

export const readdy = (seq: string) => {
  const safe = seq.replace(/[^a-zA-Z0-9._-]/g, '_');
  return img(`readdy/${safe}.jpg`);
};

export const readdyPng = (name: string) => img(`readdy/${name}.png`);

/** 从 readdy API URL 提取 seq 参数并返回本地路径 */
export const fromReaddyUrl = (url: string) => {
  if (!url) return url;
  
  const match = url.match(/[?&]seq=([^&]+)/);
  if (match) {
    return readdy(match[1]);
  }
  
  // 如果是 static.readdy.ai 的URL，提取文件名
  if (url.includes('static.readdy.ai/image')) {
    const pathMatch = url.match(/\/([a-f0-9]+\.(png|jpeg|jpg))/);
    if (pathMatch) {
      return img(`readdy/${pathMatch[1]}`);
    }
  }
  
  // 如果是 storage.readdy-site.link 的URL（Logo等）
  if (url.includes('storage.readdy-site.link')) {
    const filenameMatch = url.match(/([^\/]+\.png)/);
    if (filenameMatch) {
      return img(`readdy/${filenameMatch[1]}`);
    }
  }
  
  // 降级返回原URL
  return url;
};

/** 确保使用本地图片 - 用于从数据库加载的动态URL */
export const ensureLocalImage = (url: string | undefined, fallbackIndex: number = 0): string => {
  if (!url) return portraitAt(fallbackIndex);
  
  // 如果已经是本地路径，直接返回
  if (url.startsWith('/') || url.startsWith('./')) {
    return url;
  }
  
  // 如果是外部URL，尝试转换
  if (url.includes('readdy.ai') || url.includes('supabase.co')) {
    // 提取文件hash
    const hashMatch = url.match(/\/([a-f0-9-]+\.(png|jpeg|jpg))/);
    if (hashMatch) {
      const localPath = img(`readdy/${hashMatch[1]}`);
      // 检查本地文件是否存在（在开发环境可以检查，生产环境假设存在）
      return localPath;
    }
    // 如果无法提取hash，使用后备图片
    return portraitAt(fallbackIndex);
  }
  
  return url;
};

/** 动态条目无 Readdy 缓存时，按索引复用已下载的肖像类图片 */
const portraitPool = [
  '167da3301b1b1de99e08ec75923f5d6b',
  '4809c11142038d2b19ecef495d7d90f6',
  '5df8bbf68c1acc78bacde88c2c6b63c3',
  '7936d4133177e28c4099bd69d2972dfc',
  'b6d1aa0f3bb14a30f9100c17454f83e0',
  'f1de128490fa9be5fabd8acc49d5bf7c',
] as const;

export const portraitAt = (index: number) => img(`readdy/${portraitPool[index % portraitPool.length]}.png`);

const storeGalleryPool = [
  'd3680d44d7ac3dd36b9c80c4aed9dd9e',
  '8ccae5c9e3acdb8b0a1fb1d47b252066',
] as const;

export const storeGalleryAt = (index: number) => {
  const file = storeGalleryPool[index % storeGalleryPool.length];
  const ext = file === 'd3680d44d7ac3dd36b9c80c4aed9dd9e' ? 'jpeg' : 'png';
  return img(`readdy/${file}.${ext}`);
};

const supportModPool = [
  '167da3301b1b1de99e08ec75923f5d6b',
  'b6d1aa0f3bb14a30f9100c17454f83e0',
  'f1de128490fa9be5fabd8acc49d5bf7c',
] as const;

export const supportModAt = (index: number) => img(`readdy/${supportModPool[index % supportModPool.length]}.png`);
